export enum EscrowTypeCode {
  RealEstate = "01",
  Administration = "02",
}
